const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MOBILE_BREAKPOINT } from "@circleco/compass/hooks/useIsMobile";
import { screens } from "@circleco/compass/tailwind/screens";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers/settingsNavPathV3";
import { UNIFIED_INBOX_MESSAGES_ROOT } from "@/react/hooks/chatsV2/messaging/useMessagingPaths";

// Same media query as Compass `useIsMobile` (below `lg`); `beforeLoad` runs
// outside React, so the hook itself can't be used here.
const isMobileViewport = () => typeof window !== "undefined" && !window.matchMedia(`(min-width: ${screens[MOBILE_BREAKPOINT]})`).matches;

// Redirects in `beforeLoad` rather than rendering `<Navigate>`: the route
// component would only render through the desktop `<Outlet />` (the mobile
// view doesn't render it), and a `<Navigate>` that re-renders while the
// redirect is pending navigates again on every render (max update depth).
export const Route = createFileRoute("/_protected/settings/inbox/")({
  beforeLoad: ({
    context
  }) => {
    const settings = context.punditUserContext?.currentCommunitySettings;
    const isPriorityInboxEnabled = Boolean(settings?.priority_inbox_fe_enabled);
    const isMobileView = isMobileViewport() && Boolean(settings?.live_pulse_unified_inbox_mobile_view_enabled);
    redirect({
      // The mobile Unified Inbox has no Priority inbox tab yet, so it opens
      // on DMs.
      to: isPriorityInboxEnabled && !isMobileView ? settingsNavPathV3.unified_inbox.priority_inbox : UNIFIED_INBOX_MESSAGES_ROOT,
      replace: true,
      state: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});